module.exports = __webpack_public_path__ + "static/media/help_modules.47632cef.png";